(() => {
  const bindStickyBuy = () => {
    const bar = document.querySelector('[data-sticky-buy]');
    if (!bar) return;

    // When the product is sold out but still tagged "precommande", the
    // CTA is a [data-restock-trigger] instead (see sticky-buy-bar.liquid)
    // and is already handled by the global click listener in
    // restock-notify-modal.liquid - nothing to bind here for it, and
    // there's no real add-to-cart button in the DOM to look for in that
    // state anyway.
    const trigger = bar.querySelector('[data-sticky-buy-trigger]');
    if (trigger) {
      // Scoped to this product's own submit button (matching the id
      // buy-buttons.liquid gives it) rather than a page-wide query: an
      // unscoped "form[action*='/cart/add'] [name=add]" lookup could
      // silently match a different product's form elsewhere on the page
      // (e.g. the cross-sell section), adding the wrong item to the cart.
      const sectionId = bar.getAttribute('data-section-id');
      const addButton = sectionId ? document.getElementById(`ProductSubmitButton-${sectionId}`) : null;
      if (addButton) {
        trigger.addEventListener('click', () => {
          addButton.click();
        });
      }
    }

    const realQuantityId = bar.getAttribute('data-real-quantity-id');
    const realQuantityInput = realQuantityId ? document.getElementById(realQuantityId) : null;
    const qtyValueEl = bar.querySelector('[data-sticky-buy-qty-value]');
    const minusButton = bar.querySelector('[data-sticky-buy-qty-minus]');
    const plusButton = bar.querySelector('[data-sticky-buy-qty-plus]');
    if (!realQuantityInput || !qtyValueEl || !minusButton || !plusButton) return;

    const min = parseInt(realQuantityInput.min, 10) || 1;

    const syncFromReal = () => {
      const value = parseInt(realQuantityInput.value, 10) || min;
      qtyValueEl.textContent = value;
    };

    const setQuantity = (value) => {
      const clamped = Math.max(min, value);
      realQuantityInput.value = clamped;
      realQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      qtyValueEl.textContent = clamped;
    };

    syncFromReal();
    minusButton.addEventListener('click', () => {
      setQuantity((parseInt(qtyValueEl.textContent, 10) || min) - 1);
    });
    plusButton.addEventListener('click', () => {
      setQuantity((parseInt(qtyValueEl.textContent, 10) || min) + 1);
    });
    realQuantityInput.addEventListener('change', syncFromReal);
  };

  const bindOrderBump = () => {
    // Delegated on document (rather than bound to each button at load time):
    // the drawer's cart-order-bump button gets re-rendered by
    // cartDrawer.renderContents() below, so a direct listener would go stale
    // after the first add if a second bump product becomes eligible.
    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-order-bump-add]');
      if (!button || button.disabled) return;

      const variantId = button.getAttribute('data-variant-id');
      if (!variantId) return;

      // Update the cart drawer in place (same section-render flow as the
      // native product-form add-to-cart) instead of reloading the page:
      // a full reload drops the drawer's open state, so the customer had
      // to click the cart icon a second time to see what they just added.
      const cartDrawer = document.querySelector('cart-drawer');

      button.disabled = true;
      try {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        if (cartDrawer) {
          formData.append('sections', cartDrawer.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
        }

        const response = await fetch(window.routes ? window.routes.cart_add_url : '/cart/add', {
          method: 'POST',
          headers: { Accept: 'application/javascript' },
          body: formData,
        });
        const data = await response.json();

        if (cartDrawer) {
          if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        } else {
          window.location.reload();
        }
      } catch (error) {
        console.error('Order bump failed', error);
        button.disabled = false;
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    bindStickyBuy();
    bindOrderBump();
  }, { once: true });
})();
